import React, { useState, useEffect } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box,
  FormControl, InputLabel, Select, MenuItem, Alert
} from '@mui/material';
import { hizmetTipleri } from './PreInterviewConstants';

// Faz 4.5: tüm metin girdileri tamamı BÜYÜK HARF (tr-TR).
const capitalizeWords = (text) => {
  if (!text) return '';
  return text.toLocaleUpperCase('tr-TR');
};

// G2/G4 (2026-08-29): Paket oluşturma (isPaket/paketIcerikleri/parcaIcerikleri) ve
// fiyat alanları (fiyat/fiyatlar) UI'dan kaldırıldı. VERİDE SİLİNMEZ: serviceData bu
// alanları hiç içermediği için updateDoc mevcut değerlere dokunmaz (G11).
const ServiceFormModal = ({ isOpen, onClose, onSave, serviceToEdit }) => {
  const [hizmetAdi, setHizmetAdi] = useState('');
  const [aciklama, setAciklama] = useState('');
  const [tip, setTip] = useState('');
  const [garantiSuresiYil, setGarantiSuresiYil] = useState('');

  const serviceTypes = hizmetTipleri; // TEK KAYNAK (G12): PreInterviewConstants
  const garantiDestekliKategoriler = ['Cam Filmi', 'PPF Kaplama', 'PPF Full Body', 'Seramik Kaplama'];

  useEffect(() => {
    if (isOpen && serviceToEdit) {
      setHizmetAdi(serviceToEdit.hizmetAdi);
      setAciklama(serviceToEdit.aciklama || '');
      setTip(serviceToEdit.tip || '');
      setGarantiSuresiYil(serviceToEdit.garantiSuresiYil || '');
    } else {
      setHizmetAdi(''); setAciklama(''); setTip('');
      setGarantiSuresiYil('');
    }
  }, [serviceToEdit, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!hizmetAdi || !tip) {
      alert('Hizmet Adı ve Hizmet Tipi alanları zorunludur.');
      return;
    }

    const serviceData = {
      hizmetAdi: capitalizeWords(hizmetAdi),
      aciklama: capitalizeWords(aciklama), tip,
      ...(garantiDestekliKategoriler.includes(tip) && garantiSuresiYil
        ? { garantiSuresiYil: Number(garantiSuresiYil) }
        : {})
    };
    onSave(serviceData);
    onClose();
  };

  if (!isOpen) return null;
  const isEditing = !!serviceToEdit;
  // Eski kategorideki (Paketler / Göçük Düzeltme) bir kayıt düzenlemeye açılırsa
  // tip dropdown'da bulunmaz; mevcut tip seçenek olarak eklenir ki kayıt bozulmasın.
  const tipSecenekleri = tip && !serviceTypes.includes(tip) ? [tip, ...serviceTypes] : serviceTypes;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditing ? 'Hizmeti Düzenle' : 'Yeni Hizmet Ekle'}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate autoComplete="off" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth required>
            <InputLabel id="service-type-label">Hizmet Tipi</InputLabel>
            <Select labelId="service-type-label" value={tip} label="Hizmet Tipi" onChange={(e) => setTip(e.target.value)}>
              {tipSecenekleri.map(type => (<MenuItem key={type} value={type}>{type}</MenuItem>))}
            </Select>
          </FormControl>

          <TextField
            label="Hizmet Adı" value={hizmetAdi}
            onChange={(e) => setHizmetAdi(e.target.value)}
            onBlur={(e) => setHizmetAdi(capitalizeWords(e.target.value))}
            fullWidth required
            helperText="Kaydettiğinizde otomatik olarak düzgün formata çevrilir"
          />
          <TextField label="Açıklama" value={aciklama} onChange={(e) => setAciklama(e.target.value)} multiline rows={2} fullWidth />

          {garantiDestekliKategoriler.includes(tip) && (
            <TextField
              label="Garanti Süresi (Yıl)"
              type="number"
              value={garantiSuresiYil}
              onChange={(e) => setGarantiSuresiYil(e.target.value)}
              fullWidth
              helperText="Bu hizmet/ürün için geçerli garanti süresi (yıl olarak). Bilgi amaçlıdır; garanti kaydı harici Solar Gard sayfasında oluşturulur."
              inputProps={{ min: 0, step: 1 }}
            />
          )}

          <Alert severity="info" variant="outlined">
            Fiyatlar artık hizmet kartında tutulmaz: tutar, iş emri oluşturulurken kategori
            başına elle girilir. Eski kayıtlı fiyatlar veride korunur.
          </Alert>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained">{isEditing ? 'Güncelle' : 'Kaydet'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceFormModal;
